import { render } from "./TripCreateForm.vue?vue&type=template&id=5be23b60"
import script from "./TripCreateForm.vue?vue&type=script&lang=js"
export * from "./TripCreateForm.vue?vue&type=script&lang=js"

import "./TripCreateForm.vue?vue&type=style&index=0&id=5be23b60&lang=css"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__